import {
  isNotUndefined_default
} from "./chunk-ZNK2UXVC.mjs";

// src/monet-utils/isMaybe.ts
import F from "ramda/src/F";
import T from "ramda/src/T";
import { match, when } from "ts-pattern";
function isMaybe(obj) {
  return match(obj).with({ map: when(isNotUndefined_default) }, T).with({ "@@type": "monet.js/Maybe" }, T).otherwise(F);
}
var isMaybe_default = isMaybe;

export {
  isMaybe_default
};
//# sourceMappingURL=chunk-KQ65L4I5.mjs.map